import axios from 'axios';

import { PLACE_LKPS_LOADED, PLACE_LKPS_FAILED, PLACE_LKPS_LOADING } from './actionTypes';

axios.defaults.xsrfHeaderName = "X-XSRF-TOKEN";
axios.defaults.xsrfCookieName = 'XSRF-TOKEN';
axios.defaults.withCredentials = true;
//axios.defaults.crossDomain = true;

const dropdownMapper = el => ({ value: el.id, key: el.id, text: el.name });


const municipalityMapper = el => ({
    value: el.id,
    key: el.id,
    text: el.name,
    canton: el.canton ? el.canton.id : null,
    entity: el.entity ? el.entity.id : null
});

export const loadPlaceLKPSStarted = () => ({
    type: PLACE_LKPS_LOADING,
});

export const loadPlaceLKPSSuccess = (data) => ({
    type: PLACE_LKPS_LOADED,
    payload: data,
});

export const loadPlaceLKPSFailed = (err) => ({
    type: PLACE_LKPS_FAILED,
    error: err
});


export const loadPlaceLKPS = () => dispatch => {
    dispatch(loadPlaceLKPSStarted());
    const countriesRequest = axios.get('/countries');
    const entitiesRequest = axios.get('/entities');
    const cantonsRequest = axios.get('/cantons');
    const municipalitiesRequest = axios.get('/municipalities');

    axios.all([
        countriesRequest,
        entitiesRequest,
        cantonsRequest,
        municipalitiesRequest
    ]).then(response => {
        const [countriesR, entitiesR, cantonsR, municipalitiesR] = response;
        const bihId = countriesR.data.find(el => el._key === 'bih').id;
        const countries = countriesR.data.map(dropdownMapper);
        const fbihId = entitiesR.data.find(el => el._key === 'fbih').id;
        const entities = entitiesR.data.map(dropdownMapper);
        const cantons = cantonsR.data.map(dropdownMapper);
        const municipalities = municipalitiesR.data.map(municipalityMapper);

        const data = {
            countries,
            entities,
            cantons,
            municipalities,
            defaults: {
                bihId,
                fbihId
            }
        };
        dispatch(loadPlaceLKPSSuccess(data));
    }).catch(err => { console.log(err); dispatch(loadPlaceLKPSFailed(err)); });
};



// WEBPACK FOOTER //
// ./src/reduxFiles/placeLKPSActions.js